














































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
// import MainHeader from "@/components/main-header.vue";
import { LoginOut } from "@/request/common";
import { Md5 } from "ts-md5";
@Component({
  components: {
    // MainHeader,
  },
})
export default class Name extends Vue {
  private ifEditName: any = false;
  private ifEditPhone: any = false;
  private ifEditPassword: any = false;
  private editData: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private openEditName() {
    this.editData = JSON.parse(JSON.stringify(this.user));
    this.ifEditName = true;
  }
  private openEditPhone() {
    this.editData = JSON.parse(JSON.stringify(this.user));
    this.ifEditPhone = true;
  }
  private openEditPassword() {
    this.editData = {};
    this.ifEditPassword = true;
  }
  private saveName() {
    if (!this.editData.username) {
      this.$message.warning("请输入账号名");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      username: this.editData.username,
    };
  }
  private savePhone() {
    // 验证
    if (!this.editData.mobile) {
      this.$message.warning("请输入手机号");
      return;
    }
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.editData.mobile)) {
      this.$message.error("手机号格式不正确");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      mobile: this.editData.mobile,
    };
  }
  private savePassword() {
    // 验证
    if (!this.editData.oldPassword) {
      this.$message.warning("请输入旧密码");
      return;
    }
    if (!this.editData.newPassword) {
      this.$message.warning("请输入新密码");
      return;
    }
    if (!this.editData.rePassword) {
      this.$message.warning("请再次输入新密码");
      return;
    }
    if (this.editData.newPassword !== this.editData.rePassword) {
      this.$message.warning("新密码2次输入不一致，请重新输入");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      oldPassword: this.editData.oldPassword,
      newPassword: this.editData.newPassword,
      newPassword2: this.editData.rePassword,
    };
    // PutEditPaw(this, params, loading).then(() => {
    //   this.ifEditPassword = false;
    //   this.exit();
    // });
  }
  private exit() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    LoginOut(this, loading).then(() => {
      this.$store.commit("updateToken", "");
      this.$router.push("/access/login");
    });
  }
}
